// test2694
(2694 && 0);
